import servicesUtils from "../../../utils/servicesUtils";
function extractCursor(next) {
  if (!next) return undefined;
  try {
    var _url$searchParams$get;
    var url = next.startsWith("http") ? new URL(next) : new URL(next, window.location.origin);
    return (_url$searchParams$get = url.searchParams.get("cursor")) !== null && _url$searchParams$get !== void 0 ? _url$searchParams$get : undefined;
  } catch (_unused) {
    return undefined;
  }
}
export var getReports = function getReports(patient_id, cursor) {
  var params = {};
  if (cursor) params.cursor = cursor;
  return servicesUtils.getService("patients/".concat(patient_id, "/reports/"), params);
};
export { extractCursor as extractReportsCursor };